<template>
  <el-breadcrumb class="app-breadcrumb" separator="/">
    <transition-group name="breadcrumb">
      <el-breadcrumb-item v-for="(item,index) in levelList" :key="item.path">
        <span v-if="item.redirect==='noredirect'||index==levelList.length-1" class="no-redirect">{{ item.meta.title }}</span>
        <a v-else @click.prevent="handleLink(item)">{{ item.meta.title }}</a>
      </el-breadcrumb-item>
    </transition-group>
  </el-breadcrumb>
</template>

<script>
  // import pathToRegexp from 'path-to-regexp'
  import * as pathToRegexp from 'path-to-regexp'
  export default {
    data() {
      return {
        levelList: null
      }
    },
    watch: {
      $route(route) {
        console.log("==========================进来了")
        // if you go to the redirect page, do not update the breadcrumbs
        if (route.path.startsWith('/redirect/')) {
          return
        }
        this.getBreadcrumb()
      }
    },
    created() {
      this.getBreadcrumb()
    },
    methods: {
      getBreadcrumb() {
        // only show routes with meta.title
        let matched = this.$route.matched.filter(item => item.meta && item.meta.title)

        console.log("--------------")
        const first = matched[0]
        console.log(this.$route)
        console.log(first)
        if (!this.isDashboard(first)) {
          matched = [{ path: '/dashboard', meta: { title: '首页' }}].concat(matched)
        }
        console.log("==================== && item.meta.breadcrumb !== false")
        this.levelList = matched.filter(item => item.meta && item.meta.title )
        console.log(this.levelList)
      },
      isDashboard(route) {
        const name = route && route.name
        console.log(name)
        if (!name) {
          return false
        }
        return name.trim().toLocaleLowerCase() === '首页'.toLocaleLowerCase()
      },
      pathCompile(path) {
        // To solve this problem https://github.com/PanJiaChen/vue-element-admin/issues/561
        const { params } = this.$route
        console.log(pathToRegexp.compile(path))

        let toPath = pathToRegexp.compile(path)
        console.log(toPath)
        return toPath(params)
      },
      handleLink(item) {
        const { redirect, path } = item
        if (redirect) {
          this.$router.push(redirect)
          return
        }
        console.log(path)
        this.$router.push(this.pathCompile(path))
      }
    }
  }
</script>

<style lang="scss" scoped>
  .app-breadcrumb.el-breadcrumb {
    display: inline-block;
    font-size: 14px;
    line-height: 50px;
    margin-left: 8px;
    .no-redirect {
      color: #97a8be;
      cursor: text;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/comm/Breadcrumb/index.vue